import api from './api';

const ENDPOINT = 'card-shipping-fees';

const CardShippingFeesService = {
  get: () => api.get(ENDPOINT),
  getId: (id) => api.get(`${ENDPOINT}/${id}`),
  update: (id, data) => api.put(`${ENDPOINT}/${id}`, data),
};

export default CardShippingFeesService;
